import React from "react";

import { SvgIconProps , SvgIcon } from "@mui/material";


const DownloadIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 17 17" {...props}>
      <path
        d="M2.125 13.458H14.875V14.8747H2.125V13.458ZM9.20833 6.37467H14.1667L8.5 12.0413L2.83333 6.37467H7.79167V0.708008H9.20833V6.37467Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export default DownloadIcon;
